import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardD: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="daa724fe-f594-4591-ac91-e91d70020d0e"
  />
);
StudioProductsCatalogCardD.displayName = 'StudioProductsCatalogCardD';

export default StudioProductsCatalogCardD;
